import React, { useRef, useState } from 'react'
import Slider from "react-slick";
import { getImages } from '../Common/const';
import UseScrollReveal from '../Common/UseScrollReveal';
const slides = ['hero-slide1.webp', 'hero-slide2.webp', 'hero-slide3.webp'];
const HomeBanner = () => {
   const heroRef = useRef(null);
  const [activeSlide, setActiveSlide] = useState(0);

  const heroBanner = {
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    arrows: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    beforeChange: (oldIndex, newIndex) => {},
    afterChange: (current) => {
      setActiveSlide(current);
    },
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  UseScrollReveal()
    return (
        <>
            <section className='home-banner-wrap'>
               <Slider ref={heroRef} {...heroBanner} className='hero-slider'>
                    {slides.map((img, index) => (
                    <div key={index}>
                        <div className={`hb-item ${activeSlide === index ? 'active' : ''}`}>
                        <img src={getImages(img)} alt={`slide-${index}`} />
                        </div>
                    </div>
                    ))}
                </Slider>

                <div className='hb-pos'>
                    <div className='container'>
                        <div className='bt-title1 text-uppercase wow reveal fadeInUp'>The Finest</div>
                        <h1 className='bt-title2 text-uppercase wow reveal fadeInUp'>Pre-Owned Mercedes</h1>
                    </div>
                </div>
            </section>


        </>
    )
}

export default HomeBanner